//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from "@nuskin/ns-icon";

export default {
  name: "NsSectionHeader",
  components: { NsIcon },
  props: {
    /**
     * The subtitle text
     */
    subtitle: {
      type: String,
      default: ""
    },
    /**
     * Title text
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * The type of accent icon next to the title
     */
    titleIcon: {
      type: String,
      default: "",
      validator: value =>
        ["arrow", "heart", "spark", "squiggle", "star"].includes(value)
    }
  },
  computed: {
    titleIconName() {
      switch (this.titleIcon) {
        case "arrow":
          return "icon-freeland-arrow";
        case "heart":
          return "icon-freeland-heart";
        case "spark":
          return "icon-spark-left-24";
        case "squiggle":
          return "icon-freeland-squiggle";
        case "star":
          return "icon-freeland-star";
        default:
          return "";
      }
    }
  }
};
